module.exports = __webpack_public_path__ + "static/media/align-left.81a8ef7b.svg";